import { Button, styled, Typography, TypographyProps } from "@mui/material";

export const CustomButtonWithCheckboxRoot = styled(Button)(() => ({
	fontSize: 11,
	width: "100%",
	textWrap: "nowrap",
	alignItems: "center",
	display: "flex",
	whiteSpace: "nowrap",
	overflow: "hidden",
	textOverflow: "ellipsis",
}));

export const ButtonTextTypography = styled(Typography)<TypographyProps>(() => ({
	whiteSpace: "nowrap",
	overflow: "hidden",
	textOverflow: "ellipsis",
	maxWidth: "100%",
	lineHeight: "16px",
	fontSize: "11px",
}));
